// extracted by mini-css-extract-plugin
module.exports = {"progress":"Progress_progress__1lJ2t","block":"Progress_block__2ih8_","number":"Progress_number__8tpfz","text":"Progress_text__37JIA"};